export default "__VITE_ASSET__DJtfG0EW__"